import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { map, catchError } from 'rxjs/operators';
import { APIService } from 'src/app/shared/service/apiService.service';
import { ModeService } from 'src/app/shared/service/mode.service';
import { PlanModulesService } from 'src/app/shared/service/plan-modules.service';
import Swal from 'sweetalert2';
import { NgbNav } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls:['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {

  @ViewChild('nav', { static: false }) nav: NgbNav;
  public loginForm: FormGroup;
  public registerForm: FormGroup;
  public isLoading = false;
  public submitted = false;
  public submittedLogin = false;
  forgotPasswordForm: FormGroup;
  isSubmitting: boolean = false;
  submittedForgot: boolean = false;
  showPassword: boolean = false;

  private subs: Array<Subscription> = [];

  constructor(
    private formBuilder: FormBuilder,
    private authService: APIService,
    private router: Router,
    private modeService: ModeService,
    private planModulesService: PlanModulesService,
  ) {}

  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
      password: ['', Validators.required]
    })

    this.registerForm = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      businessname: ['', Validators.required],
      email: ['', [Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
      password: ['', Validators.required],
      confirmedPassword: ['', [Validators.required]]
    })

    this.forgotPasswordForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
    });
  }

  forgotPassword() {
    this.submittedForgot = true;

    if (this.forgotPasswordForm.invalid) {
        return;
    }

    this.isSubmitting = true;
    const email = this.forgotPasswordForm.controls['email'].value;

    this.authService.forgotPassword({email})
        .pipe(
            map(response => {
                Swal.fire({
                    title: 'Éxito',
                    text: 'Se ha enviado un correo electrónico para restablecer su contraseña.',
                    icon: 'success',
                    confirmButtonText: 'OK'
                  }).then(() => {
                    // Seleccionar la pestaña de "Iniciar sesión" programáticamente
                    this.nav.select(1);  // Aquí seleccionamos la pestaña de "Iniciar sesión"
                });
                this.isSubmitting = false;
            }),
            catchError(err => {
                Swal.fire({
                    title: 'Error',
                    text: 'Hubo un problema al enviar el correo electrónico. Por favor intenta nuevamente.',
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
                this.isSubmitting = false;
                return throwError(err);
            })
        ).subscribe();
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub: Subscription) => sub.unsubscribe());
  }

  public get formState() {
    return this.loginForm.controls;
  }

  private validatePasswords(): void {
    const password: string = this.registerForm.get('password').value;
    const confirmPassword: string = this.registerForm.get('confirmedPassword').value;
    if (password !== confirmPassword) {
      this.registerForm.controls['confirmedPassword'].setErrors({ incorrect: true });
    };
  }

  private buildUser() {
    return {
      firstName: this.registerForm.controls['firstName'].value,
      lastName: this.registerForm.controls['lastName'].value,
      businessname: this.registerForm.controls['businessname'].value,
      password: this.registerForm.controls['password'].value,
      email: this.registerForm.controls['email'].value
    }
  }

  private loginUser() {
    return {
      email: this.loginForm.controls['email'].value,
      password: this.loginForm.controls['password'].value
    }
  }

  onSubmit() {
    this.submittedLogin = true;
  
    if (this.loginForm.invalid) {
      return;
    }
  
    const user: any = this.loginUser();
    this.isLoading = true;
  
    this.subs.push(
      this.authService.login(user)
        .pipe(
          map((data: any) => {
            if (data.Message) {
              Swal.fire({
                title: 'Error de Acceso',
                text: 'Error al acceder. Ingresa datos válidos.',
                icon: 'error',
                confirmButtonText: 'OK'
              });
              this.isLoading = false;
              return;
            }
  
            // Guardar el usuario en localStorage
            localStorage.setItem('currentUser', JSON.stringify(data));
            this.planModulesService.applyAuthPayload(data);

            this.modeService.initFromSession();
  
            // Verificar si hay una URL de redirección guardada (por ejemplo, de una invitación)
            const redirectUrl = localStorage.getItem('redirectAfterLogin');
            
            if (redirectUrl) {
              // Limpiar la URL de redirección y navegar allí
              localStorage.removeItem('redirectAfterLogin');
              console.log('🔄 [REDIRECT] Redirigiendo a URL guardada:', redirectUrl);
              this.router.navigateByUrl(redirectUrl);
              return;
            }
  
            this.router.navigateByUrl('/inicio');
          }),
          catchError(err => {
            this.isLoading = false;
            Swal.fire({
              title: 'Error de Acceso',
              text: 'Verifica que tus datos sean correctos.',
              icon: 'error',
              confirmButtonText: 'OK'
            });
            return throwError(err);
          })
        ).subscribe()
    );
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  /* registerUser() {
    this.submitted = true;
    this.validatePasswords();

    if (this.registerForm.invalid) {
      return;
    }
    const user: any = this.buildUser();
    this.isLoading = true;
    this.subs.push(
      this.authService.signUp(user)
        .pipe(
          map(() => {
            this.handleUserCreation();
            setTimeout(() => {
              window.location.reload();
            }, 1800);
          }),
          catchError(error => this.handleError(error))
        )
        .subscribe()
    );
  } */

}
